import clsx from "clsx";
import { ContentBlock, ContentBlockType, MaybeStored } from "../types";

export default function ContentBlockComponent({
  block,
}: {
  block: MaybeStored<ContentBlock>;
}) {
  if (block.legacy && block.html) {
    return <div dangerouslySetInnerHTML={{ __html: block.html }}></div>;
  }

  if (block.type === ContentBlockType.ImageWithDescription) {
    return (
      <div
        className={clsx(
          "static-block static-block--with-image",
          block.inverted && "static-block--inverted",
        )}
      >
        <img
          className="static-block__image"
          src={block.imageURL}
          alt={block.imageAlt}
        />
        <div className="static-block__text">
          <h3 className="static-block__title">{block.title}</h3>
          <div
            className="wysiwyg"
            dangerouslySetInnerHTML={{ __html: block.body }}
          ></div>
        </div>
      </div>
    );
  }

  if (block.type === ContentBlockType.TitleWithDescription) {
    return (
      <div className="static-block">
        <div className="static-block__text">
          <h3 className="static-block__title">{block.title}</h3>
          <div
            className="wysiwyg"
            dangerouslySetInnerHTML={{ __html: block.body }}
          ></div>
        </div>
      </div>
    );
  }

  if (block.type === ContentBlockType.BigImage) {
    return (
      <div className="static-block">
        <img
          className="static-block__image"
          src={block.imageURL}
          alt={block.imageAlt}
        />
      </div>
    );
  }

  return null;
}
